(() => {
  const selector = '#mirage-search';
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);

  const initialize = () => {
    const overlay = document.querySelector(selector);
    if (!overlay || overlay.dataset.ready) return;
    overlay.dataset.ready = 'true';
    const form = overlay.querySelector('form');
    const input = overlay.querySelector('.mirage-search__input');
    const close = overlay.querySelector('.mirage-search__close');
    const clear = overlay.querySelector('.mirage-search__clear');
    const browse = overlay.querySelector('[data-mirage-search-browse]');
    const results = overlay.querySelector('[data-mirage-search-results]');
    let opener = null;
    let timer = null;
    let currentRequest = 0;

    const setOpen = (open, trigger) => {
      if (open) {
        opener = trigger || document.activeElement;
        overlay.hidden = false;
        requestAnimationFrame(() => overlay.classList.add('is-open'));
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mirage-search-open');
        document.querySelectorAll('.mirage-search-trigger').forEach(button => button.setAttribute('aria-expanded', 'true'));
        window.setTimeout(() => input.focus(), 80);
      } else {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mirage-search-open');
        document.querySelectorAll('.mirage-search-trigger').forEach(button => button.setAttribute('aria-expanded', 'false'));
        window.setTimeout(() => { overlay.hidden = true; }, 180);
        opener?.focus?.();
      }
    };

    const showBrowse = () => {
      browse.hidden = false;
      results.hidden = true;
      results.replaceChildren();
      clear.hidden = true;
    };

    const productCard = (product) => {
      const image = product.image || product.featured_image?.url || '';
      const price = product.price || product.price_min || '';
      return `<a class="mirage-search__card" href="${escapeHtml(product.url)}"><span class="mirage-search__card-image">${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" width="360" height="360" loading="lazy">` : ''}</span><span class="mirage-search__card-brand">${escapeHtml(product.vendor || 'Mirage Luggage')}</span><span class="mirage-search__card-title">${escapeHtml(product.title)}</span>${price ? `<span class="mirage-search__card-price">${escapeHtml(price)}</span>` : ''}</a>`;
    };

    const renderResults = (term, payload) => {
      const found = payload?.resources?.results || {};
      const products = (found.products || []).slice(0, 4);
      const collections = (found.collections || []).slice(0, 4);
      browse.hidden = true;
      results.hidden = false;
      if (!products.length && !collections.length) {
        results.innerHTML = `<p class="mirage-search__empty">No matches for “${escapeHtml(term)}”. Try a product name, color, or category.</p>`;
        return;
      }
      const productHtml = products.length ? `<section><p class="mirage-search__results-heading">Products</p><div class="mirage-search__cards">${products.map(productCard).join('')}</div><a class="mirage-search__view-all" href="/search?q=${encodeURIComponent(term)}&type=product">View all results&nbsp; →</a></section>` : '';
      const collectionHtml = collections.length ? `<section class="mirage-search__collections"><p class="mirage-search__results-heading">Collections</p>${collections.map(collection => `<a class="mirage-search__collection" href="${escapeHtml(collection.url)}">${escapeHtml(collection.title)}&nbsp; →</a>`).join('')}</section>` : '';
      results.innerHTML = `<div class="mirage-search__result-layout">${productHtml}${collectionHtml}</div>`;
    };

    const search = async (term) => {
      const query = term.trim();
      clear.hidden = !query;
      if (query.length < 2) { showBrowse(); return; }
      const requestId = ++currentRequest;
      results.hidden = false;
      browse.hidden = true;
      results.innerHTML = '<p class="mirage-search__empty">Searching…</p>';
      const parameters = new URLSearchParams({ q: query, 'resources[type]': 'product,collection', 'resources[limit]': '4', 'resources[options][unavailable_products]': 'hide' });
      try {
        const response = await fetch(`/search/suggest.json?${parameters.toString()}`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        const payload = await response.json();
        if (requestId === currentRequest) renderResults(query, payload);
      } catch (_) {
        if (requestId === currentRequest) results.innerHTML = `<p class="mirage-search__empty">Search is taking a moment. Press Enter to see all results for “${escapeHtml(query)}”.</p>`;
      }
    };

    document.querySelectorAll('.mirage-search-trigger').forEach(trigger => trigger.addEventListener('click', () => setOpen(true, trigger)));
    close.addEventListener('click', () => setOpen(false));
    clear.addEventListener('click', () => { input.value = ''; showBrowse(); input.focus(); });
    input.addEventListener('input', () => { window.clearTimeout(timer); timer = window.setTimeout(() => search(input.value), 180); });
    form.addEventListener('submit', event => { if (!input.value.trim()) event.preventDefault(); });
    overlay.addEventListener('click', event => { if (event.target === overlay) setOpen(false); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && !overlay.hidden) setOpen(false); });
    showBrowse();
  };

  document.addEventListener('DOMContentLoaded', initialize);
  if (document.readyState !== 'loading') initialize();
})();
